(() => {
  const PRODUCT_ROOT = 'main[data-template^="product"]';

  function osmoPicker(root) {
    return [...root.querySelectorAll('variant-picker[data-product-title]')].find((picker) =>
      /osmo/i.test(picker.dataset.productTitle || '')
    );
  }

  function optionLabels(picker) {
    const labels = new Map();

    picker.querySelectorAll('input[type="radio"][value]').forEach((input) => {
      const text = cleanSwatchLabel(input.value);
      const match = text.match(/\b(\d{3,4})\b/);
      if (match) labels.set(match[1], text);
    });

    return labels;
  }

  function cleanSwatchLabel(value) {
    const text = String(value || '').trim().replace(/\s+/g, ' ');
    const codeIndex = text.search(/\b\d{3,4}\b/);
    if (codeIndex < 0) return '';

    return text
      .slice(codeIndex)
      .replace(/\s*(?:\/|-)?\s*\d+(?:\.\d+)?\s*(?:ml|l|liter|litre|fl\.?\s*oz\.?)\b.*$/i, '')
      .replace(/\s+(?:official\s+wood\s+swatch|wood\s+swatch|colou?r\s+swatch|swatch|finish\s+on\s+wood)$/i, '')
      .trim();
  }

  function isColorSwatch(image) {
    const alt = image.getAttribute('alt')?.trim().replace(/\s+/g, ' ') || '';
    const source = decodeURIComponent(image.currentSrc || image.src || '');
    const searchable = `${alt} ${source}`;

    const isVariantComposite =
      /\bwith centered\b.*\bswatch\b/i.test(alt) ||
      /(?:^|[-_])variant(?:[-_.]|$)/i.test(source);
    if (isVariantComposite) return false;

    if (
      /\b(?:can|tin|bottle|container|package|packaging|kit|brush|roller|applicator|holder|tool|lifestyle|in use|application|product view|main image)\b/i.test(
        searchable
      )
    ) {
      return false;
    }

    const isExplicitSwatch =
      /\b(?:color|colour|wood|finish)?\s*swatch\b/i.test(alt) ||
      /(?:swatch|colour|color)[-_ ]/i.test(source);
    const isWideWoodPreview =
      image.naturalWidth > 0 &&
      image.naturalHeight > 0 &&
      image.naturalWidth / image.naturalHeight > 1.65 &&
      /\b(?:finish on wood|wood finish|colou?r)\b/i.test(alt);

    return isExplicitSwatch || isWideWoodPreview;
  }

  function labelFromImage(image, labels) {
    if (!isColorSwatch(image)) return '';

    const alt = image.getAttribute('alt')?.trim().replace(/\s+/g, ' ') || '';
    let match = alt.match(/\b(\d{3,4})\s+(.+?)(?:\s+(?:color|finish|official wood swatch))?$/i);

    if (match) {
      const number = match[1];
      return cleanSwatchLabel(labels.get(number) || `${number} ${match[2]}`);
    }

    const source = image.currentSrc || image.src || '';
    const filename = decodeURIComponent(source.split('/').pop()?.split('?')[0] || '')
      .replace(/\.[a-z0-9]+$/i, '')
      .replace(/_[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}$/i, '');

    match = filename.match(/(?:^|[-_])(\d{3,4})[-_ ]*([a-z][a-z0-9_-]*)/i);
    if (!match) return '';

    const number = match[1];
    return cleanSwatchLabel(labels.get(number) || `${number} ${match[2].replace(/[-_]+/g, ' ')}`);
  }

  function removeLabels(image) {
    const container = image.closest('.product-media-container');
    container?.querySelector(':scope > .mw-swatch-media-label')?.remove();

    const button = image.closest(
      '.slideshow-controls__thumbnail, .dialog-thumbnails-list__thumbnail'
    );
    if (!button) return;

    button.classList.remove('mw-swatch-thumbnail--labeled');
    button.removeAttribute('title');
    button.querySelector(':scope > .mw-swatch-thumbnail-label')?.remove();
  }

  function addMainLabel(image, label) {
    const container = image.closest('.product-media-container');
    if (!container || image.closest('button')) return;

    let badge = container.querySelector(':scope > .mw-swatch-media-label');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'mw-swatch-media-label';
      badge.setAttribute('aria-hidden', 'true');
      container.appendChild(badge);
    }
    if (badge.textContent !== label) badge.textContent = label;
  }

  function addThumbnailLabel(image, label) {
    const button = image.closest(
      '.slideshow-controls__thumbnail, .dialog-thumbnails-list__thumbnail'
    );
    if (!button) return;

    const number = label.match(/^\d{3,4}/)?.[0];
    if (!number) return;

    button.classList.add('mw-swatch-thumbnail--labeled');
    button.title = label;

    let caption = button.querySelector(':scope > .mw-swatch-thumbnail-label');
    if (!caption) {
      caption = document.createElement('span');
      caption.className = 'mw-swatch-thumbnail-label';
      caption.setAttribute('aria-hidden', 'true');
      button.appendChild(caption);
    }
    if (caption.textContent !== number) caption.textContent = number;
  }

  function annotate() {
    const root = document.querySelector(PRODUCT_ROOT);
    if (!root) return;

    const picker = osmoPicker(root);
    if (!picker) return;

    const labels = optionLabels(picker);
    root.querySelectorAll('media-gallery img, product-media-gallery img').forEach((image) => {
      const label = labelFromImage(image, labels);
      if (!label) {
        removeLabels(image);
        return;
      }
      addMainLabel(image, label);
      addThumbnailLabel(image, label);
    });
  }

  let queued = false;
  const queueAnnotation = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      annotate();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', annotate, { once: true });
  } else {
    annotate();
  }

  new MutationObserver(queueAnnotation).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();

